import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

const authConfig = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
  },
});

export function getDashboardStats(companyId) {
  return axios.get(
    `${API_END_POINT}/company/dashboard/${companyId}`,
    authConfig()
  );
}
